/*
Add following data parameters to HTML tags.
Open and close attributes must be added
directly to the trigger element.

[data-menu="overlay"] => menu overlay element
[data-menu="open"] => menu open button
[data-menu="close"] => menu close button
*/

export default class Menu {
  constructor() {
    this.menu = document.querySelector('[data-menu="overlay"]');
    this.openButton = document.querySelector('[data-menu="open"]');
    this.closeButton = document.querySelector('[data-menu="close"]');

    this.showMenu = this.showMenu.bind(this);
    this.hideMenu = this.hideMenu.bind(this);

    this.init();
  }

  init() {
    if (!this.menu || !this.openButton) return;
    this.bindEvents();
  }

  bindEvents() {
    this.openButton.addEventListener('click', this.showMenu);
    this.closeButton.addEventListener('click', this.hideMenu);
  }

  showMenu(e) {
    e.preventDefault();
    this.menu.style.visibility = 'visible';
    this.menu.style.opacity = '1';
  }

  hideMenu(e) {
    e.preventDefault();
    this.menu.style.visibility = 'hidden';
    this.menu.style.opacity = '0';
  }
};
